<template>
  <ContentSection class="accordion-component">
    <Container indent="container-tight">
      <!-- ACCORDION -->
      <Accordion
        v-for="(el, index) in data.accordion_group"
        :key="index"
        class="group mt-3.5 first-of-type:mt-0 md:mt-6"
        :duration-open="300"
      >
        <template #summary>
          <div
            class="focus-default flex cursor-pointer list-none flex-row items-center rounded-lg border-3 border-amber-100 py-3 px-4 text-base transition-colors hover:bg-amber-100 group-open:bg-amber-100 sm:px-7 md:px-8 lg:py-4 lg:text-2xl"
          >
            <IconPlus
              class="mr-8 w-6 shrink-0 text-pink-500 blue:text-blue-500 green:text-green-500 lg:mr-[2.8rem] lg:w-8"
            />
            <h3 class="leading-tight">{{ el.heading }}</h3>
          </div>
        </template>
        <template #content>
          <div
            class="text prose-a:hover-underline-animation-prose prose-sm !max-w-text py-6 px-5 sm:px-7 lg:px-[2.375rem] lg:py-12 lg:pl-28 xl:prose-lg"
            v-html="el.text"
          />
        </template>
      </Accordion>
    </Container>
  </ContentSection>
</template>

<script setup>
defineProps({
  data: { type: Object, required: true },
})
</script>

<style>
.text-component + .accordion-component {
  @apply !pt-2;
}
.accordion-component:has(+ .text-component) {
  @apply !pb-2;
}

.text ul p {
  hyphens: auto;
}
</style>
